import * as THREE from "three";

const nPointsCircle = function (count, radius) {
  const positions = new Float32Array(count * 3);

  for (let i = 0; i < count; i++) {
    const theta = (i / count) * Math.PI * 2;
    const index = i * 3;
    positions[index] = Math.cos(theta) * radius;
    positions[index + 1] = Math.sin(theta) * radius;
    positions[index + 2] = 0;
  }
  const geometry = new THREE.BufferGeometry();
  geometry.setAttribute("position", new THREE.BufferAttribute(positions, 3));
  return geometry;
};

const nPointsGeometry = function (count) {
  const getRandom = function (min, max, count = 100) {
    const values = new Float32Array(count);
    for (let i = 0; i < count; i++) {
      values[i] = Math.random() * (max - min) + min;
    }
    return values;
  };

  const positions = new Float32Array(count * 3);
  const indices = new Float32Array(count);
  for (let i = 0; i < count; i++) {
    const index = i * 3;
    positions[index] = 0;
    positions[index + 1] = 0;
    positions[index + 2] = 0;
    indices[i] = i;
  }
  const geometry = new THREE.BufferGeometry();
  geometry.setAttribute("position", new THREE.BufferAttribute(positions, 3));
  geometry.setAttribute(
    "aRandSmall",
    new THREE.BufferAttribute(getRandom(0.9, 1.1, count), 1)
  );
  geometry.setAttribute(
    "aRandLarge",
    new THREE.BufferAttribute(getRandom(0.7, 1.3, count), 1)
  );
  geometry.setAttribute("vIndex", new THREE.BufferAttribute(indices, 1));
  return geometry;
};

export { nPointsCircle, nPointsGeometry };
